import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 16832 16832"
    {...props}
  >
    <path
      d="M4656 15291h7520c856 0 1635-351 2199-916 565-564 916-1343 916-2199V4656c0-856-351-1635-916-2200-564-565-1343-916-2199-916H4656c-858 0-1637 350-2200 914v2c-565 565-916 1344-916 2200v7520c0 856 351 1635 916 2199 565 565 1344 916 2200 916zm7520 1289H4656c-1212 0-2314-495-3111-1293-798-798-1294-1899-1294-3111V4656c0-1212 496-2314 1294-3111l1 1C2345 747 3446 251 4656 251h7520c1212 0 2313 496 3111 1294 798 797 1293 1899 1293 3111v7520c0 1212-495 2313-1293 3111s-1899 1293-3111 1293z"
      style={{
        // fill: "#2b2a29",
        fillRule: "nonzero",
        // stroke: "#2b2a29",
        strokeWidth: 502.438,
      }}
      className="fill stroke1"
    />
  </svg>
);
export default SvgComponent;
